// extracted by mini-css-extract-plugin
export default {"bgvideo":"BackgroundVideo_bgvideo__iENjd"};